import { Form } from 'factorial-form'
import _ from 'lodash'

class SupplementValidationForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      id: 'number',
      supplement_id: 'number',
      employee_id: 'number',
      author_id: 'number',
    })
  }

  get validationData() {
    const data = this.data()

    const attrs = _.pick(data, ['id', 'employee_id', 'author_id', 'supplement_id'])

    return { ...attrs }
  }
}

export default SupplementValidationForm
